import React from 'react';
import { observer } from 'mobx-react';
import { Spin } from 'antd';

import Modal from './Modal';
import Store from './Store';
import MainTable from './MainTable';
import Toolbar from './Toolbar';
import MainTableDomain from './MainTableDomain';
import dashboardStore from '@stores/dashboard';
import * as api from '@stores/api';

class ExclusionDoctor extends React.Component {
  componentDidMount() {
    if (!api.isAdminOrMagStaffOrAccounting()) {
      dashboardStore.close('/view/exclusion-specialist', true);
      return;
    }
    Store.fetchData(true);
    Store.fetchDoctors();
  }
  render() {
    const { data, loading, open, loadingDoctor } = Store;
    return (
      <div className={`Table-${(loading && !data) || loadingDoctor ? 'loading' : 'container'}`}>
        {(loading && !data) || loadingDoctor ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <Toolbar />
            {Store.type === 'doctor' ? <MainTable /> : <MainTableDomain />}
            {open && <Modal />}
          </React.Fragment>
        )}
      </div>
    );
  }
}
export default observer(ExclusionDoctor);
